import { Outlet } from "react-router-dom";
import PropTypes from "prop-types";
import AuthHeader from "./AuthHeader";
import CopyrightFooter from "./CopyrightFooter";

// ==============================|| LAYOUT - AUTH ||============================== //

export default function AuthLayout({ children }) {
  return (
    <>
      {/* <Outlet /> */}

      <div className="d-flex justify-content-between vh-100 overflow-auto flex-column">
        <AuthHeader />
        <div>
          {/* {children} */}
          <Outlet />
        </div>
        <CopyrightFooter />
      </div>
    </>
  );
}

AuthLayout.propTypes = { children: PropTypes.node };
